import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appMagnify]'
})
export class MagnifyDirective {
  
  constructor(private elementRef: ElementRef) { }

  @HostListener('mousemove', ['$event']) onMouseMove(event: MouseEvent) {
    const img = this.elementRef.nativeElement as HTMLImageElement;
    const rect = img.getBoundingClientRect();

    const offsetX = event.clientX - rect.left;
    const offsetY = event.clientY - rect.top;

    const scaleX = img.width / rect.width;
    const scaleY = img.height / rect.height;

    const bgPosX = `${offsetX * scaleX}px`;
    const bgPosY = `${offsetY * scaleY}px`;

    img.style.backgroundPosition = `${bgPosX} ${bgPosY}`;
  }
  // magnifier: HTMLElement | undefined;

  // constructor(private renderer: Renderer2, private el: ElementRef) { }

  // @HostListener('mouseover') onMouseOver() {
  //   const imgSrc = this.el.nativeElement.src;
  //   // Create magnifier container
  //   this.magnifier = this.renderer.createElement('div');
  //   this.renderer.addClass(this.magnifier, 'magnifier');
  //   this.renderer.appendChild(this.el.nativeElement, this.magnifier);

  //   // Create magnified image
  //   const magnifiedImage = this.renderer.createElement('img');
  //   this.renderer.setAttribute(magnifiedImage, 'src', imgSrc);
  //   this.renderer.appendChild(this.magnifier, magnifiedImage);
  // }

  // @HostListener('mousemove', ['$event']) onMouseMove(event: MouseEvent) {
  //   // Update magnified image position based on mouse position
  //   const offsetX = 50; // Adjust as needed
  //   const offsetY = 50; // Adjust as needed
  //   this.renderer.setStyle(this.magnifier, 'left', `${event.clientX + offsetX}px`);
  //   this.renderer.setStyle(this.magnifier, 'top', `${event.clientY + offsetY}px`);
  // }

  // @HostListener('mouseout') onMouseOut() {
  //   // Remove magnifier container
  //   if (this.magnifier) {
  //     this.renderer.removeChild(this.el.nativeElement, this.magnifier);
  //     this.magnifier = undefined;
  //   }
  // }

}
